<template>
  <div id="billing_preferences">
    <!-- <div
      v-for="item in billingPreferences"
      :key="item.id"
      class="border mb-3 rounded-lg"
    >
  </div> -->
    <div class="border rounded-lg">
      <div class="align-items-center bg-light-f6f6f6 card-header justify-content-between">
        <div class="d-flex">
          <h6 class="font-weight-semibold mb-0">
            {{ $t(billingPreferences.title) }} 
            <!-- ({{ $t(item.subtitle) }}) -->
          </h6>
          <a
            href="javascript:void(0);"
            @click="selectAddress(billingPreferences.id)"
            class="ml-auto text-primary"
          >
            <i class="fa-regular fa-location-check mr-2" />
            {{ $t("Select Address") }}
          </a>
        </div>
      </div>

      <div class="card-body pb-0 pt-2">
        <!-- <div class="d-flex mb-3 mt-1">
          <span class="font-weight-semibold">{{ $t("Receipt Address") }}</span>
          <a
            href="javascript:void(0);"
            @click="selectAddress(item.id)"
            class="ml-auto text-primary"
          >
            <i class="fa-regular fa-location-check mr-2" />
            {{ $t("Select Address") }}
          </a>
        </div> -->
        <div class="align-content-start d-flex mt-2 py-2 rounded-6px">
          <div class="mx-2">
            <dl 
              class="row mb-0" 
              v-if="billingPreferences.id == 'isRequestReciept'"
            >
              <dt class="col-3">
                {{ $t("Full Name") }}:
              </dt>
              <dd class="col-9">
                {{ fullNameReciept }}
              </dd>
              <dt class="col-3">
                {{ $t("Address") }}:
              </dt>
              <dd class="col-9">
                {{ addressReciept }}
              </dd>
              <dt class="col-3">
                {{ $t("Phone") }}:
              </dt>
              <dd class="col-9">
                {{ phoneReciept }}
              </dd>
              <dt class="col-3">
                {{ $t("Tax ID") }}:
              </dt>
              <dd class="col-9">
                {{ taxIdReciept }}
              </dd>
            </dl>
            <dl 
              class="row mb-0" 
              v-else-if="billingPreferences.id == 'isRequestWithholdingTax'"
            >
              <dt class="col-3">
                {{ $t("Full Name") }}:
              </dt>
              <dd class="col-9">
                {{ fullNameWithholdingTax }}
              </dd>
              <dt class="col-3">
                {{ $t("Address") }}:
              </dt>
              <dd class="col-9">
                {{ addressWithholdingTax }}
              </dd>
              <dt class="col-3">
                {{ $t("Phone") }}:
              </dt>
              <dd class="col-9">
                {{ phoneWithholdingTax }}
              </dd>
              <dt class="col-3">
                {{ $t("Tax ID") }}:
              </dt>
              <dd class="col-9">
                {{ taxIdWithholdingTax }}
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <!-- <span 
        v-if="item.isRequest"
        class="select-plan"
      >
        <i class="fa-solid fa-check" />
      </span> -->
    </div>
    <div class="pt-2">
      <div>
        <!-- <span class="form-text mt-0 mb-2 text-danger">
          <i class="fas fa-times-circle" />
          {{ $t('Tax ID is required to be used for withholding tax purposes.') }}
        </span> -->
        <span 
          v-if="
            (billingPreferences.isRequest || billingPreferences.isRequestTax) && 
            taxIdWithholdingTax && 
            taxIdWithholdingTax.length != 13
          "
          class="form-text mt-0 mb-2 text-danger"
        >
          <i class="fas fa-times-circle" />
          {{ $t('The tax id must consist of only 13 digits.') }}
        </span>
        <span 
          v-else-if="
            (taxIdWithholdingTax != '' && taxIdWithholdingTax != null && taxIdWithholdingTax != '-') && 
            !isValidTaxId
          "
          class="form-text mt-0 mb-2 text-danger"
        >
          <i class="fas fa-times-circle" />
          {{ $t('The tax id must consist of only 13 digits.') }}
        </span>

        <span 
          v-else-if="
            (billingPreferences.isRequest || billingPreferences.isRequestTax) && 
            (taxIdWithholdingTax == '' || taxIdWithholdingTax == null || taxIdWithholdingTax == '-')
          "
          class="form-text mt-0 mb-2 text-danger"
        >
          <i class="fas fa-times-circle" />
          {{ $t('Tax ID is required to be used for invoice or withholding tax purposes.') }}
        </span>
      </div>
      <div class="form-check mb-2">
        <label class="form-check-label">
          <div class="uniform-checker ">
            <span :class="[(billingPreferences.isRequestTax ? 'checked' : '')]">
              <input
                type="checkbox"
                class="custom-control-input"
                @click="selectTaxInvoice(billingPreferences)"
              >
            </span>
          </div>
          <div>
            {{ $t('Tax Invoice') }}
          </div>
        </label>
      </div>
      <div class="form-check">
        <label class="form-check-label">
          <div class="uniform-checker ">
            <span :class="[(billingPreferences.isRequest ? 'checked' : '')]">
              <input
                type="checkbox"
                class="custom-control-input"
                @click="selectBillingPreferences(billingPreferences)"
              >
            </span>
          </div>
          <div>
            {{ $t('_Plan.Withholding tax') }}
          </div>
        </label>
      </div>
      <span class="border-0 card mb-1 pl-4 text-grey-300">
        *{{ $t(billingPreferences.remark) }}
      </span>

      <div 
        v-if="billingPreferences.isRequest"
        class="form-group mb-0"
      >
        <label>{{ $t("แนบเอกสารหัก ณ ที่จ่าย") }}</label>
        <div class="position-relative">
          <VueUploadMultipleImage
            :max-image="limitImage"
            @upload-success="uploadImageSuccess"
            @before-remove="beforeRemove"
            @edit-image="editImage"
            :data-images="images"
            :show-primary="false"
            id-upload="myIdUpload"
            edit-upload="myIdEdit"
            :drag-text="$t('Drag Image')"
            :browse-text="$t('Browse Image')"
            primary-text="Base image"
            mark-is-primary-text="Set base image"
            popup-text="default base image"
            :drop-text="$t('Drag and drop')"
            :accept="typeFile"
          />
        </div>
        <span class="form-text text-muted">{{ mutedMaxUploadImg }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import VueUploadMultipleImage from '@/plugins/VueUploadMultipleImage.vue';
export default {
  components: {
    VueUploadMultipleImage,
  },
  data() {
    return {
      // billingPreferences: [
      //   // {
      //   //   id: 'isRequestReciept',
      //   //   title: 'Request Receipt / Tax Invoice',
      //   //   subtitle: 'Personal Tax',
      //   //   remark: '',
      //   //   isRequest: false,
      //   // },
      //   // {
      //   //   id: 'isRequestWithholdingTax',
      //   //   title: 'Request Withholding Tax',
      //   //   subtitle: 'Corporate Tax',
      //   //   remark: 'Please send the withholding tax document to the company within 15 days. Once the company receives the document, the original receipt/tax invoice will be sent through postal',
      //   //   isRequest: false,
      //   // },
      //   {
      //     id: 'isRequestWithholdingTax',
      //     title: 'Receipt / Tax Invoice',
      //     subtitle: '',
      //     remark: 'Please send the withholding tax document to the company within 15 days. Once the company receives the document, the original receipt/tax invoice will be sent through postal',
      //     isRequest: false,
      //   },
      // ],
      billingPreferences: {
        id: 'isRequestWithholdingTax',
        title: '_ShippingCredit.Receipt / Tax Invoice',
        subtitle: '',
        remark: 'Please send the withholding tax certificate to the company within 15 days. Once the company receives the document, the original receipt/invoice will be sent via Thailand Post.',
        isRequest: false,
        requestTax: 'isRequestTax',
        isRequestTax: false,
      },
      limitImage: 5,
      limitImageSize: 30,
      typeFile: 'image/jpeg,image/png,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf',
      images: [],
        
    };
  },
  created() {
    // this.billingPreferences.map((item) => { 
    //   item.isRequest = this.$parent.orders[item.id];
    // });
  },
  computed: {
    fullNameReciept() {
      let location = Object.keys(this.$parent.locationDataSelectReciept).length > 0 ? this.$parent.locationDataSelectReciept : this.$parent.locationDataSelect;
      return location ? location.name : "-";
    },
    addressReciept() {
      let location = Object.keys(this.$parent.locationDataSelectReciept).length > 0 ? this.$parent.locationDataSelectReciept : this.$parent.locationDataSelect;
      return location
        ? `${location.address1}, ${location.county}, ${location.city}, ${location.state}, ${location.postcode}`
        : "-";
    },
    phoneReciept() {
      let location = Object.keys(this.$parent.locationDataSelectReciept).length > 0 ? this.$parent.locationDataSelectReciept : this.$parent.locationDataSelect;
      return location ? location.telephone1 : "-";
    },
    taxIdReciept() {
      let location = Object.keys(this.$parent.locationDataSelectReciept).length > 0 ? this.$parent.locationDataSelectReciept : this.$parent.locationDataSelect;
      return location ? location.tax_type == "personal" ? location.tax_identification : location.business_tax : "-";
    },
    fullNameWithholdingTax() {
      let location = Object.keys(this.$parent.locationDataSelectWithholdingTax).length > 0 ? this.$parent.locationDataSelectWithholdingTax : this.$parent.locationDataSelect;
      return location ? location.name : "-";
    },
    addressWithholdingTax() {
      let location = Object.keys(this.$parent.locationDataSelectWithholdingTax).length > 0 ? this.$parent.locationDataSelectWithholdingTax : this.$parent.locationDataSelect;
      return location
        ? `${location.address1}, ${location.county}, ${location.city}, ${location.state}, ${location.postcode}`
        : "-";
    },
    phoneWithholdingTax() {
      let location = Object.keys(this.$parent.locationDataSelectWithholdingTax).length > 0 ? this.$parent.locationDataSelectWithholdingTax : this.$parent.locationDataSelect;
      return location ? location.telephone1 : "-";
    },
    taxIdWithholdingTax() {
      let location = Object.keys(this.$parent.locationDataSelectWithholdingTax).length > 0 ? this.$parent.locationDataSelectWithholdingTax : this.$parent.locationDataSelect;
      return location ? location.tax_type == "personal" ? location.tax_identification : location.business_tax : "-";
    },
    mutedMaxUploadImg: function () {
      return this.$t("You can choose to upload a maximum of 5 images. The size is not over 30 MB. (File extensions supported by .png, .jpeg, .pdf, .xlsx)");
    },
    isValidTaxId() {
      const regex = /^\d{13}$/;
      return regex.test(this.taxIdWithholdingTax);
    }
  },
  methods: {
    selectBillingPreferences(item) {
      //Check
      item.isRequest = item.isRequest === false ? true : false;
      // this.billingPreferences[item.id].isRequest = item.isRequest == false ? true : false;
      this.$parent.orders[item.id] = this.$parent.orders[item.id] === false ? true : false;
      //Disable
      if(item.isRequest == true) {
        let keyDisable = item.id == 'isRequestReciept' ? 'isRequestWithholdingTax' : 'isRequestReciept';
        // let indexDisable = item.id == 'isRequestReciept' ? 1 : 0;
        // this.billingPreferences[indexDisable].isRequest = item.isRequest === false ? true : false;
        this.$parent.orders[keyDisable] = this.$parent.orders[item.id] === false ? true : false;
      }
      this.$parent.calculateOrdersSummary();
    },
    selectTaxInvoice(item){
      item.isRequestTax = item.isRequestTax === false ? true : false;
      this.$parent.orders[item.requestTax] = this.$parent.orders[item.requestTax] === false ? true : false;
    },
    selectAddress(type) {
      this.$parent.isSelectAddress = true;
      this.$parent.loadSelectAddress(type);
    },
    uploadImageSuccess(formData, index, fileList, fileSize) {
      let imgSize = fileSize / 1000000;
      let imgList = fileList;
      if (index >= this.limitImage || imgSize > this.limitImageSize) {
        imgList.splice(index, 1);
        const self = this.$parent;
        this.$toastr.w(this.$t(this.mutedMaxUploadImg),this.$t("Warning"));
      }
      this.images = imgList;
      this.$parent.imageData = fileList;
    },
    beforeRemove(index, done, fileList, mediaId) {
      var r = confirm("remove image");
      if (r == true) {
        this.$parent.imageData = fileList;
        done();
        if (mediaId) {
          delMedia(mediaId);
        }
      } else {
      }
    },
    editImage(formData, index, fileList) {
      this.$parent.imageData = fileList;
    },
    clearData(){
      this.billingPreferences.isRequest = false;
    },
  },
};
</script>

    <style scoped>
.form-check {
  margin-bottom: 0;
}

.uniform-choice span:after {
  transition: none;
}

dt {
  color: #8c8c8c;
}

dd {
  margin-bottom: 0;
}
span.select-plan {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 18px 18px;
    border-color: transparent transparent #007bff transparent;
}
span.select-plan>i,
span.select-plan>span {
    position: absolute;
    right: 2px;
    top: 9px;
    font-size: 7px;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/account-setting/premium-subscriptions/payment-modal/TaxInvoice.vue